import React from 'react';
import ResourceSectionCard from './ResourceSectionCard';
import VideoSection from './VideoSection';
import { resourceSections, trainingVideos } from './data';

const Resources = () => {
    const [primarySection, secondarySection, documentationSection] = resourceSections;

    return (
        <main className="min-h-full bg-[#F7F5F2] flex flex-col gap-6 md:gap-8 px-4 md:px-8 pt-5 md:pt-8 pb-8">
            <header>
                <h1 className="text-[28px] md:text-[36px] leading-[34px] md:leading-[44px] font-medium tracking-[-0.75px] text-[#2d2d2d]">
                    Resources
                </h1>
                <p className="mt-1.5 text-[14px] leading-[22px] text-[#6b6b6b]">
                    Training videos, templates, and assets to help you get the most out of Claraview
                </p>
            </header>

            <VideoSection title="Training Videos" videos={trainingVideos} />

            <section className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
                <ResourceSectionCard {...primarySection} />
                <ResourceSectionCard {...secondarySection} />
            </section>

            <ResourceSectionCard {...documentationSection} />
        </main>
    );
};

export default Resources;
